/* MONARCH — interacciones propias (prefijo mt-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal, .mt-hero');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: lo que ya está en pantalla se muestra aunque el observador tarde
    setTimeout(function () {
      els.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('mt-visible');
      });
    }, 1500);
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-mt-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-mt-parallax')) || 0;
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-r.top * k / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-mt-count'));
      var dec = (String(target).split('.')[1] || '').length;
      if (reduce || isNaN(target)) { el.textContent = el.getAttribute('data-mt-count'); return; }
      var start = null, dur = 1800;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initAnatomia() {
    document.querySelectorAll('[data-mt-anat]').forEach(function (root) {
      var steps = root.querySelectorAll('.mt-anat__step');
      var imgs = root.querySelectorAll('.mt-anat__visual img');
      var counter = root.querySelector('.mt-anat__counter');
      if (!steps.length) return;
      function activate(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
        if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(steps.length).padStart(2, '0');
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-gallery]').forEach(function (g) {
      var main = g.querySelector('.mt-prod__main img');
      var thumbs = g.querySelectorAll('.mt-prod__thumb');
      if (!main) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.classList.add('is-fading');
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.removeAttribute('srcset');
            main.alt = t.getAttribute('data-alt') || '';
            main.classList.remove('is-fading');
          }, 220);
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-product]').forEach(function (root) {
      var json = root.querySelector('[data-mt-variants]');
      var selects = root.querySelectorAll('[data-mt-option]');
      if (!json || !selects.length) return;
      var variants = JSON.parse(json.textContent);
      var scope = root.closest('.shopify-section') || root;
      var idInputs = scope.querySelectorAll('input[name="id"]');
      var mainImg = root.querySelector('.mt-prod__main img');
      var thumbs = root.querySelectorAll('.mt-prod__thumb');
      root.querySelectorAll('[data-mt-swatches]').forEach(function (w) {
        var sel = w.querySelector('[data-mt-option]'), name = w.querySelector('[data-mt-swatch-name]');
        w.querySelectorAll('.mt-swatch').forEach(function (b) {
          b.addEventListener('click', function () {
            w.querySelectorAll('.mt-swatch').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
            b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
            if (name) name.textContent = b.getAttribute('data-value');
            sel.value = b.getAttribute('data-value');
            sel.dispatchEvent(new Event('change'));
          });
        });
      });
      var price = root.querySelector('[data-mt-price]');
      var compare = root.querySelector('[data-mt-compare]');
      var btns = root.querySelectorAll('[data-mt-add]');
      var stock = root.querySelector('[data-mt-stock]');
      function update() {
        var vals = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        btns.forEach(function (b) {
          b.disabled = !v || !v.available;
          var label = b.querySelector('span');
          if (label) label.textContent = (v && v.available) ? b.getAttribute('data-label-add') : b.getAttribute('data-label-soldout');
        });
        if (!v) return;
        idInputs.forEach(function (i) { i.value = v.id; });
        if (v.media && mainImg && mainImg.getAttribute('src') !== v.media) {
          mainImg.classList.add('is-fading');
          setTimeout(function () { mainImg.src = v.media; mainImg.removeAttribute('srcset'); mainImg.classList.remove('is-fading'); }, 220);
          var base = v.media.split('?')[0].replace(/_\d+x\d*(?=\.)/, '');
          thumbs.forEach(function (th) { th.classList.toggle('is-active', (th.getAttribute('data-src') || '').split('?')[0].replace(/_\d+x\d*(?=\.)/, '') === base); });
        }
        if (price) price.textContent = v.price_formatted;
        if (compare) { compare.textContent = v.compare_formatted || ''; compare.hidden = !v.compare_formatted; }
        if (stock) { stock.classList.toggle('is-out', !v.available); stock.textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out'); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  function initStickyBuy() {
    var bar = document.querySelector('.mt-sticky-buy');
    var form = document.querySelector('.mt-prod__form');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(form);
  }

  function init() {
    initReveals(); initParallax(); initCounters(); initAnatomia(); initGaleria(); initVariantes(); initStickyBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
